import { render, staticRenderFns } from "./ApproveOrEditButton.vue?vue&type=template&id=876994e2&"
import script from "./ApproveOrEditButton.vue?vue&type=script&lang=js&"
export * from "./ApproveOrEditButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports